
const Keycloak = require('keycloak-js');
const axios = require('axios');
const envUtils = require('../../shared/utils')


function IntegratedBespinSso(alertNowInternalOpenApiUrl) {
    this.alertNowInternalOpenApiUrl = alertNowInternalOpenApiUrl;
    console.log(this.alertNowInternalOpenApiUrl);

    var that = this;

    this.init = function() {
        return new Promise(function (resolve, reject) {
            try {
                axios.get(that.alertNowInternalOpenApiUrl + '/api/v1/keycloak/json', {
                    params: {
                        domain: window.location.hostname,
                        svcType: 'frontend'
                    }
                }).then(function(response) {
                    var keycloakJson = response.data.result.keycloakJson;

                    that.keycloak = new Keycloak(JSON.parse(keycloakJson));
                    

                    var options = {
                        onLoad: 'check-sso',
                        //silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
                        //token: envUtils.EnvUtils.envCdToAccessToken(),
                        //idToken: envUtils.EnvUtils.envCdToAccessToken(),
                        //refreshToken: envUtils.EnvUtils.envCdToRefreshToken(),
                        checkLoginIframe: true,
                    };
                    that.keycloak.init(options);
                    console.log(that.keycloak);
                    resolve(that.keycloak);
                });
            } catch (e) {
                reject(e);
            }
        });
    };

    this.getKeycloak = function() {
        return this.keycloak;
    };

    this.isAlertNowUser = function() {
        if (!that.keycloak || !that.keycloak.idTokenParsed) {
            return false;
        }

        return that.keycloak.idTokenParsed.alertnow === true;
    };

    this.getSessionCount = function() {
        return new Promise(function (resolve, reject) {
            try {
                var authServerUrl = that.keycloak.authServerUrl;
                var realm = that.keycloak.realm;
                var clientId = that.keycloak.clientId;
                var token = that.keycloak.token;

                axios.get(authServerUrl + '/realms/' + realm + '/api/users/me/session-count', {
                    headers: {
                        Authorization: 'Bearer ' + token
                    },
                    params: {
                        clientId: clientId
                    }
                }).then(function (response) {
                    resolve(response.data.count);
                });
            } catch (e) {
                reject(e);
            }
        });
    };

    this.logoutAllSession = function(withoutCurrent) {
        return new Promise(function (resolve, reject) {
            try {
                var authServerUrl = that.keycloak.authServerUrl;
                var realm = that.keycloak.realm;
                var clientId = that.keycloak.clientId;
                var token = that.keycloak.token;

                axios.get(authServerUrl + '/realms/' + realm + '/api/users/me/logout-allsession', {
                    headers: {
                        Authorization: 'Bearer ' + token
                    },
                    params: {
                        clientId: clientId,
                        withoutCurrent: withoutCurrent
                    }
                }).then(function () {
                    resolve();
                });
            } catch (e) {
                reject(e);
            }
        });
    };


    this.customLogout = function(options) {
        options = options || null;
        if(that.isAlertNowUser()) {
            const modifiedLogoutUrl = that.keycloak.createLogoutUrl().split('?')[0] + '?client_id=' + that.keycloak.clientId + 
                                        '&post_logout_redirect_uri=' + window.location.origin ; 
            window.location.href = modifiedLogoutUrl; 
        } else {
            that.keycloak.logout(Object.assign({}, options));
        }
    }

}

module.exports = IntegratedBespinSso;



//////////////////
// WEBPACK FOOTER
// ./src/app/components/sso/integrated.bespinsso.js
// module id = ./src/app/components/sso/integrated.bespinsso.js
// module chunks = main